type MoveAction = 'before' | 'after';

interface StepMoveData {
  targetStepId: string;
  action: MoveAction;
}

/**
 * Resolves the correct targetStepId and action to send to the API when moving
 * a step.
 *
 * The API interprets action:'after' as "append after all steps that follow
 * targetStepId" rather than "insert immediately after targetStepId".
 * For rightward moves, convert to action:'before' the next step so the item
 * lands in the correct position. When moving to the last position there is
 * no next step, so the original 'after' behavior is correct (appends to end).
 */
export function resolveStepMoveData(
  steps: string[],
  to: number,
  targetStepId: string,
  action: MoveAction
): StepMoveData {
  if (action === 'after') {
    const nextStepId = steps[to + 1];
    if (nextStepId) {
      return { targetStepId: nextStepId, action: 'before' };
    }
  }

  return { targetStepId, action };
}
